module.exports = __webpack_public_path__ + "img/check.08841fb3.jpg";